import { ReactElement } from 'react';

const ErrorContent = (): ReactElement => <p>To continue further with this application, please fix the problem(s) highlighted below</p>;

export default ErrorContent;
